var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2500 2500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Gradient_bez_nazwy_126);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#Gradient_bez_nazwy_121);\n      }\n\n      .cls-3 {\n        fill: url(#Gradient_bez_nazwy_76);\n      }\n\n      .cls-4 {\n        fill: url(#Gradient_bez_nazwy_41);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_bez_nazwy_76",
    "data-name": "Gradient bez nazwy 76",
    x1: 380.55,
    y1: 1647.67,
    x2: 1815.63,
    y2: 2476.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f277e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#387fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#377bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3372b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2e62a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274b97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274b97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_bez_nazwy_41",
    "data-name": "Gradient bez nazwy 41",
    x1: 426.58,
    y1: 809.67,
    x2: 930.68,
    y2: 1682.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f277e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3981c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_bez_nazwy_126",
    "data-name": "Gradient bez nazwy 126",
    x1: 1906.45,
    y1: 923.6,
    x2: 482.4,
    y2: 923.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2f277e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#302d83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#4397d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#459bdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3981c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_bez_nazwy_121",
    "data-name": "Gradient bez nazwy 121",
    x1: 2248.1,
    y1: 1631.02,
    x2: 1368.38,
    y2: 1631.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f277e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2f2d82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#324f9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3467ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3575ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367bbe"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2049.14,2071.58c-2.16,12.05-161.16,10.37-339.7-42.88-115.36-34.41-111.8-52.45-199.48-69.68-154.05-30.25-280.92,2.67-327.38,15.28-39.69,10.74-126.55,35.03-214.76,94.48-22.81,15.38-41.61,30.34-84.94,58.23-40.74,26.2-89.63,57.65-131.73,76.36-140.14,62.24-284.03,18.12-295.86,14.31-46.54-14.97-121.24-39-167.04-111.66-37.37-59.29-36.63-121.04-36.28-151.76.18-14.23,1.99-85.95,45.82-163.22,10.41-18.33,19.66-30.73,30.07-42.64.72,21.08,6.71,34.92,12.22,43.87,56.21,91.28,302.72,66.57,467.63-39.12,8.16-5.22,15.9-10.51,23.26-15.82,46.4-29.18,115.55-61.89,202.17-68.3,66.64-4.92,120.93,7.42,158.76,16.02,15.45,3.5,62.11,14.68,134.82,46.03,90.08,38.85,125.83,67.97,260.38,145.55,63.18,36.44,94.75,54.65,129.53,72.11,190.9,95.88,334.58,111.29,332.49,122.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1033.86,729.06c-21.88-6.46-45.12-8.8-69.17-4.75-12.55,2.12-58.43,9.85-92.82,47.57-21.41,23.49-31.51,51.13-38.27,89.32-28.81,162.77,39.59,313.03,44.49,323.5,26.59,56.66,40.39,62.15,55.86,113.71,4.16,13.82,22.93,79.26,12.87,165.73-9.03,77.54-36.65,132.68-60.45,180.19-20.11,40.11-40.6,71.61-56.04,93.39.21-.14.43-.27.64-.41-7.36,5.31-15.1,10.61-23.26,15.82-164.91,105.69-411.42,130.41-467.63,39.12-5.51-8.95-11.5-22.79-12.22-43.87,15.55-17.77,33.77-34.41,62.52-68.06,43.7-51.13,82.82-96.91,111.66-160.36,56.17-123.44,43.68-248.22,38.05-298.74-1.03-9.15-1.52-11.81-6.31-43.13-33.85-221.18-50.76-331.76-51.23-389.66-.02-2.65-.04-5.27-.08-7.96v-.02c53.93-38.38,131.63-80.05,231.13-96.48,125.4-20.71,235.49,6.93,320.25,45.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1906.45,1583.59c-75.83-19.99-161.62-49.96-251.66-95.29-120.3-60.57-214.99-131.87-286.4-196.5v-.02c-7.88-17.79-15.63-36.4-23.2-55.86-25.98-66.88-38.65-115.63-92.8-254.06-33.48-85.6-42.22-101.72-54.52-119.49-5.51-7.94-38.6-55.26-87.62-92.72,0-.02-.02-.02-.04-.02-22.46-17.17-48.25-32.23-76.28-40.54-.02,0-.04,0-.06-.02-84.76-38.17-194.85-65.81-320.25-45.1-99.5,16.43-177.2,58.1-231.13,96.48-.56-76.43.33-167.13,48.07-268.79,51.66-109.93,126.86-166.24,144.05-178.64,33.98-24.54,91.79-66.29,172.91-69.25,54.48-1.99,98.68,14.29,139.2,33.65,61.31,29.27,174.18,94.24,313.23,256.37,29.21,34.06,134.98,160.34,233.17,359.61,37.58,76.3,28.03,69.83,80.03,186.77,122.64,275.7,185.9,417.88,293.3,483.41Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2247.72,1865.83c-.86,10.8-6.27,61.64-46.4,88.17-23.67,15.63-49.01,15.96-69.62,16.23-38.01.51-66.97-10.41-78.87-15.08-272.39-106.91-388.63-218.09-388.63-218.09-72.07-68.92-111.84-129.88-169.37-218.09-33.79-51.79-81.81-126.18-126.45-227.18,71.41,64.64,166.1,135.93,286.4,196.5,90.04,45.33,175.83,75.3,251.66,95.29,3.5,2.12,7.05,4.18,10.65,6.15,162.4,89.08,184.46,98.6,184.46,98.6,33.34,14.38,63.84,25.75,93.97,56.83,13.99,14.46,57.05,58.92,52.2,120.65Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.6c0dd5e24091091f1e42473546176aab.svg";
export { ForwardRef as ReactComponent };